// Recent pages, favorite pages, and recent/favorite entities (useRecentPages.js,
// useFavoritePages.js, useEntityMemory.js) all persist to localStorage, which is shared
// by every account that ever logs in on the same browser. Without scoping, User B logging
// in after User A on a shared machine inherits User A's recent/pinned nav items. Namespacing
// every key by the current user's id keeps each account's list separate.
export function getScopedKey(baseKey) {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return baseKey;
    const parsed = JSON.parse(raw);
    return parsed?.id != null ? `${baseKey}_${parsed.id}` : baseKey;
  } catch {
    return baseKey;
  }
}
